import { Component, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { AddSuperadminComponent } from '../add-superadmin/add-superadmin.component';
import { UpdateSuperadminComponent } from '../update-superadmin/update-superadmin.component';

@Component({
  selector: 'app-list-superadmin',
  standalone: false,
  templateUrl: './list-superadmin.component.html',
  styleUrl: './list-superadmin.component.scss'
})

export class ListSuperadminComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  isDisabled: boolean = false;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  constructor(

    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService


  ) {
    this.user_reference = this.localstorage.getUsers().data.reference;
    console.log("this.user_reference", this.user_reference);
    this.FecthDataService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.getListeSuperAdministrateur();
    });
  }

  ngOnInit() {
   
  }
  openModal() {
    this.modalService.open(AddSuperadminComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  editOpenModal(item: any) {
    this.localstorage.saveAdministrateur(item);
    this.modalService.open(UpdateSuperadminComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  
  getListeSuperAdministrateur() {
    this.isLoading = true;

    this.authService.getSuperAdministrateur(this.user_reference).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();

        console.log("la reponse du webservice", this.items);

      },
      (error) => {
        console.log("une erreu est survenu", error);

      }
    )
  }
  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }


  confirmSuppression(item: any) {
    console.log("item",item);

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir supprimer  :'  + item?.nom + '?',

      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui', // Définir le libellé du bouton "Oui"
      rejectLabel: 'Non', // Définir le libellé du bouton "Non"
      accept: () => {
        this.ngxService.start();
        const requestData = {
          superadmin_id :this.user_reference
        }
        this.authService.deleteSuperAdministrateur(item.reference,requestData).subscribe(

          (response: any) => {
            //console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: "AFRICEREAL", detail: response.message });
            this.getListeSuperAdministrateur();
            this.ngxService.stop();

          },
          (error) => {

            //console.log("une erreur est survenu",error);
            this.messageService.add({ severity: 'error', summary: "AFRICEREAL", detail: error.message });
            this.ngxService.stop();

          },
        )
      },
      // reject: () => {
      //     this.messageService.add({ severity: 'warn', summary: Constant.suiviTitle, detail: 'La suppression du programme est annulée.', life: 3000 });
      // }
    });
  }

 
  filterBySearchTerm() {
    if (!this.searchTerm) {
      this.filteredtems = this.items; // Si la recherche est vide, affiche tous les éléments
    } else {
      const search = this.searchTerm.toLowerCase();
  
      this.filteredtems = this.items.filter(item =>
        (item?.nom && item.nom.toLowerCase().includes(search)) ||
        (item?.prenom && item.prenom.toLowerCase().includes(search)) ||
        (item?.email && item.email.toLowerCase().includes(search)) ||
        (item?.telephone && item.telephone.toLowerCase().includes(search))
      );
    }
    
    this.updatePaginated(); // Mise à jour de la pagination après filtrage
  }
 
  
}